export const close = {
	name: 'close',
	title: 'Close',
	content:
		'<path d="M 0.75,23.249l22.5-22.5 " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 23.25,23.249l-22.5-22.5" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
